<ng-template #reviewStrategiesInfo>
  <div class="review-strategies upload-client h-100 d-flex flex-column" [ngClass]="{'rap-maximized-review': isRapMaximized}">
    <div class="d-flex flex-column mb-3 review-progress">
      <div class="mb-2">
        <img *ngIf="reviewedCount && reviewedCount === strategies.length" src="../../../../images/core-focus/success-circle.png"/>
        {{reviewedCount}} out of {{strategies.length}} strategies reviewed.
      </div>
      <div class="d-flex">
        <div class="progress-bar-sec" [ngClass]="{'completed-progress-bar' : i < reviewedCount}" *ngFor="let item of strategies;let i = index">
        </div>
      </div>
    </div>
    <div class="d-flex mb-3 flex-fill min-h-0">
      <div class="strategies-list d-flex flex-column">
        <div class="bold heading header-col">Selected Strategies</div>
        <div class="d-flex flex-column padding-10 flex-fill min-h-0 overflow-auto">
          <div class="pointer strategy-info-box d-flex flex-column mt-2 mb-2" [ngClass]="{'selected-strategy' : item.selected}" *ngFor="let item of strategies;let i = index" (click)="selectStrategy(item)">
            <div class="d-flex flex-column" style="width: 100%;">
              <div class="d-flex justify-content-between move-strategy">
                <div class="bold strategy-name mb-2">
                  {{item.name}}
                  <!-- <span class="badge-tooltip move-right" *ngIf="item.suggestedInfo">
                    <img src="../../../../images/core-focus/information.png"/>
                    <span class="tooltip-text move-right">
                      <div>Why this strategy?</div>
                      {{item.suggestedInfo}}
                    </span>
                  </span> -->
                      <span *ngIf="item.suggestedInfo"
                            data-bs-toggle="tooltip"
                            data-bs-html="true"
                            class="cursor-auto"
                            [attr.title]="getTooltipContent('Why this strategy?', item?.suggestedInfo)">
                        <img src="../../../../images/core-focus/information.png"/>
                      </span>
                </div>
                <div *ngIf="item.reviewed">
                  <img style="width: 18px;height: 18px;" src="../../../../images/core-focus/reviewed-success.png"/>
                </div>
              </div>
              <div class="bold strategy-desc" *ngIf="item.description">
                <div class="pointer toggle-description mb-2" (click)="toggleDescription(item); $event.stopPropagation()">
                  {{ item.showFullDescription ? 'View Less' : 'View More' }}
                </div>
                <div [innerHTML]="item.showFullDescription ? item.description : (stripHtml(item.description) | slice:0:300) + ' ...'"></div>
              </div>
              <div class="strategy-savings" *ngIf="item.planAmount !== null">
                <div class="mt-3 mb-2 field-descriptor">
                  Est. Plan Amount
                  <span class="amount-box">{{item.planAmount | formatAmount:'$0,0'}}</span>
                  <!-- <span class="badge-tooltip move-right"  *ngIf="item.fieldDescriptor">
                      <img src="../../../../images/core-focus/information.png"/>
                      <span class="tooltip-text move-right">
                        <div>Amount Descriptor</div>
                        {{item.fieldDescriptor}}
                      </span>
                  </span> -->
                  <span *ngIf="item.fieldDescriptor" data-bs-toggle="tooltip" data-bs-html="true" class="cursor-auto"
                    [attr.title]="getTooltipContent('Amount Descriptor', item?.fieldDescriptor)">
                    <img src="../../../../images/core-focus/information.png" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="strategy-info d-flex flex-column">
        <div class="d-flex header-col">
          <div style="width: 35%">
            <div class="bold heading">Tax Strategy</div>
          </div>
          <div style="width: 65%" class="d-flex strategy-buttons justify-content-end" *ngIf="strategies && strategies.length > 0">
            <div class="pointer pe-2" (click)="removeStrategy()">
              <img style="width: 18px;height: 18px;" src="../../../../images/core-focus/trash-icon.png"/>
              Remove Strategy</div>
            <div class="ps-2" *ngIf="showField">
              <input type="checkbox" style="cursor: pointer" [(ngModel)]="reviewAndAddToPlan" (change)="addToPlan()"> Review & Add to Plan
            </div>
          </div>
        </div>
        <div #scrollContainer class="flex-fill min-h-0 overflow-auto" style="padding: 15px;">
          <div class="d-flex flex-column" *ngIf="strategies && strategies.length > 0">
            <div class="d-flex mt-2 mb-2">
              <div style="font-size: 14px;"><strong>{{currentSelectedStrategy.name || ''}}</strong></div>
            </div>
            <div class="d-flex flex-column mt-2 mb-2">
              <div class="w-100">
                <label>
                  Related Party: <span style="color: #F06459">*</span>
                </label>
              </div>
              <div class="w-100">
                <label  *ngIf="showField">
                  <app-tpiq-select-dropdown [setData]="clientsList" [includeNone]="false" (onValueSelect)="setClient($event)"
                                         [setDefaultValue]="newStrategy.clientId" [setSearchKey]="'name'" [setPlaceHolder]="'Pick Related Party'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
                </label>
              </div>
            </div>
            <div class="d-flex mt-2 mb-2">
              <div class="d-flex flex-column w-100 strategy-info-field">
                <div>
                  <label>
                    <span>Create Task Date</span>
                    <span class="text-center badge-tooltip move-right">
                      <i class="icon ion-ios-information-outline"></i><span class="pe-2">:</span>
                      <span class="tooltip-text move-right">
                        A task will be created for the strategy once you fill in the task date field here.
                      </span>
                    </span>
                  </label>
                </div>
                <div>
                  <label *ngIf="showField">
                    <input style="margin-bottom: 0;" class="float-left input-field" type="text" tpiq-custom-datepicker [attr.format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="newStrategy.goalDate"
                           placeholder="Create Task Date" (valueChanged)="updateGoalDate($event, newStrategy)"/>
                  </label>
                </div>
              </div>
              <div class="d-flex flex-column w-100">
                <div>
                  <label>Recurring</label>
                </div>
                <div *ngIf="showField">
                  <input type="checkbox" [(ngModel)]="newStrategy.recurring" [checked]="newStrategy.recurring" />
                </div>
              </div>
            </div>
            <div class="d-flex mt-2 mb-2">
              <div class="d-flex flex-column w-100 strategy-info-field">
                <div>
                  <label>Start Year: <span style="color: #F06459">*</span></label>
                </div>
                <div>
                  <label *ngIf="showField">
                    <app-tpiq-input-search [setData]="years" [setColName]="''" [setPlaceHolder]="'Start Year'" [setMasterRow]="''" [setSearchKey]="'name'" [setValueKey]="'id'"
                                        [setDefaultValue]="newStrategy.sinceYear" (onValueSelect)="selectYear($event, 'sinceYear')"
                                        (onCharacterTyped)="selectYear($event, 'sinceYear')"></app-tpiq-input-search>
                  </label>
                </div>
              </div>
              <div class="d-flex flex-column w-100">
                <div>
                  <label>End Year:</label>
                </div>
                <div>
                  <label *ngIf="showField">
                    <app-tpiq-input-search [setData]="years" [setColName]="''" [setPlaceHolder]="'End Year'" [setMasterRow]="''" [setSearchKey]="'name'" [setValueKey]="'id'"
                                        [setDefaultValue]="newStrategy.toYear" (onValueSelect)="selectYear($event, 'toYear')"
                                        (onCharacterTyped)="selectYear($event, 'toYear')"></app-tpiq-input-search>
                  </label>
                </div>
              </div>
            </div>
            <div class="d-flex  flex-column mt-2 mb-2">
              <div class="w-100">
                <label class="review-plan-amount">
                  <span>Est. Plan Amount</span>
                  <span class="text-center badge-tooltip move-right">
                    <i class="icon ion-ios-information-outline"></i><span class="pe-2">:</span>
                    <span class="bottomTooltiptext" style="width: 382px; margin-left: -80px; font-size: 12px; padding: 5px; transform: none;">
                    The Plan Amount represents the tax deduction or credit used to calculate tax savings. For investment-based strategies, this may differ from the cash invested.
                    </span>
                  </span>
                </label>
              </div>
              <div class="w-100">
                <label class="d-flex review-field input-action-badge" *ngIf="showField">
                  <input style="margin-bottom: 0;" class="float-left input-field" placeholder="Plan Amount" type="text" [(ngModel)]="newStrategy.amount" (blur)="calculateResultAmount(newStrategy, true)"
                         model-numeral [locale]="'USD'" [format]="'$0,0'" [readonly]="newStrategy?.investmentEnabled && isInvestmentFeature"/>
                  <span class="action-badge">
                      <span class="bold pointer" (click)="createTaskForReviewField('Plan Amount', newStrategy.amount, 'amount')">
                        <img class="info-icon" src="../../../../images/core-focus/flag.png"/>Create a Task
                      </span>
                    </span>
                </label>
              </div>
            </div>
            <!--Investment field during RAP Process -->
            <div class="d-flex flex-column mt-2 mb-2" *ngIf="newStrategy?.investmentEnabled && isInvestmentFeature">
              <div class="w-100">
                <label class="review-plan-amount">
                  <span>Strategy Investment Amount</span>
                  <span class="text-center badge-tooltip move-right">
                    <i class="icon ion-ios-information-outline"></i><span class="pe-2">:</span>
                    <span class="bottomTooltiptext" style="width: 300px; margin-left: 0; font-size: 12px; padding: 5px;transform: none;left: -55px;" [innerHTML]="newStrategy?.investmentDescription || ''"></span>
                  </span>
                </label>
              </div>
              <div class="input-with-icon">
                <input class="input-field" type="text" placeholder="Investment Amount" [(ngModel)]="newStrategy.investedAmount"
                  model-numeral [locale]="'USD'" [format]="'$0,0'" (ngModelChange)="calculateInvestmentAmount(newStrategy)" />
              </div>

            </div>
            <div class="d-flex mt-2 mb-2">
              <div class="d-flex flex-column w-100 strategy-info-field">
                <div>
                  <label>Federal Associated Rate: <span style="color: #F06459">*</span></label>
                </div>
                <div>
                  <label *ngIf="showField">
                    <app-tpiq-select-dropdown [includeNone]="false" [setData]="allAssociatedData[newStrategy.strategyId] || associatedWith" (onValueSelect)="setAssociatedWith($event, 'federal')"
                                           [setDefaultValue]="defaultStrategyId" [setSearchKey]="'name'" [setPlaceHolder]="'Pick Fed Rate'" [setValueKey]="'id'">
                    </app-tpiq-select-dropdown>
                  </label>
                </div>
              </div>
              <div class="d-flex flex-column w-100">
                <div>
                  <label>State Associated Rate: </label>
                </div>
                <div>
                  <label *ngIf="showField">
                    <app-tpiq-select-dropdown [includeNone]="false" [setData]="allStateAssociatedData" (onValueSelect)="setAssociatedWith($event, 'state')"
                                           [setDefaultValue]="defaultStateAssociatedId" [setSearchKey]="'name'" [setPlaceHolder]="'Pick State Rate'" [setValueKey]="'id'">
                    </app-tpiq-select-dropdown>
                  </label>
                </div>
              </div>
            </div>
            <div class="d-flex mt-2 mb-2">
              <div class="w-100 strategy-info-field d-flex flex-column">
                <div>
                  <label>
                    <span>Fed Tax Saved</span>
                    <span class="text-center badge-tooltip move-right">
                      <i class="icon ion-ios-information-outline"></i><span>: </span>
                      <span class="tooltip-text move-right" style="width: 185px;">
                        {{ getTaxSavedTooltip(newStrategy, 'federal') }}
                      </span>
                    </span>
                  </label>
                </div>
                <div  *ngIf="showField" class="total-color">{{newStrategy.roiAmount | formatAmount:'$0,0'}}</div>
              </div>
              <div class="w-100 d-flex flex-column">
                <div>
                  <label>
                    <span>State Tax Saved</span>
                    <span class="text-center badge-tooltip move-right">
                      <i class="icon ion-ios-information-outline"></i><span>: </span>
                      <span class="tooltip-text move-right" style="width: 185px;">
                        {{ getTaxSavedTooltip(newStrategy, 'state') }}
                      </span>
                    </span>
                  </label>
                </div>
                <div  *ngIf="showField" class="total-color">{{newStrategy.stateRoiAmount | formatAmount:'$0,0'}}</div>
              </div>
            </div>
            <div class="d-flex flex-column mt-2 mb-2">
              <div class="w-100">
                <label>
                  Notes for implementing {{currentSelectedStrategy?.name || ''}} (internal note):
                </label>
              </div>
              <div class="w-100">
                <label class="d-flex" *ngIf="showField">
                  <textarea class="w-100" placeholder="Write your notes here." [(ngModel)]="newStrategy.notes" style="height: 100px; resize: none;"></textarea>
                </label>
              </div>
            </div>
            <div class="d-flex flex-column mt-2 mb-2">
              <div class="pointer add-text" (click)="toggleAddCustomRate(!showAddCustomRateInPopup)">
                <span style="position: relative;bottom: 5px;">
                  <i class="icon float-left add-icon ion-ios-plus-outline" *ngIf="!showAddCustomRateInPopup"></i>
                  <i class="icon float-left add-icon ion-ios-minus-outline" *ngIf="showAddCustomRateInPopup"></i>
                </span>
                Custom Rate
              </div>
              <div class="d-flex mb-5" *ngIf="showAddCustomRateInPopup" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding: 15px;">
                <div class="strategy-info-field">
                  <input type="text" [(ngModel)]="newCustomRate.name" placeholder="Name"/>
                </div>
                <div class="strategy-info-field">
                  <input type="text" [(ngModel)]="newCustomRate.rate" placeholder="24"/>
                </div>
                <div>
                  <button class="pointer" style="padding: 5px 13px;background: #FFFFFF;margin-top: 5px;border: 1px solid #1570EF;border-radius: 6px;color: #0B58CB;" (click)="appendNewCustomRate()">Add</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
